import * as React from "react";
import { Link as ChakraLink, type LinkProps as ChakraLinkProps } from "@chakra-ui/react";

export const Link: React.FC<ChakraLinkProps> = ({ children, ...rest }) => {
  return <ChakraLink {...rest}>{children}</ChakraLink>;
};
